import { useState } from "react";
import { Box, Stepper, Step, StepLabel, Grid, Button } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import DiscourseDetails from "./discourseDetails";
import DiscourseTokenGatingConfiguration from "./discourseTokenGatingConfiguration";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import DiscourseBrandingDetails from "./DiscourseBrandingDetails";

const steps = [
  "Discourse Details",
  "Token Gating Configuration",
  "Branding Details",
];

const DiscourseTokenGatingForm = () => {
  const { register } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);

  const [discourseDetails, setDiscourseDetails] = useState({
    forumLink: "",
    discourseAPI: "",
    adminForumUserName: "",
    discourseConnectSecret: "",
    customerKeyForOTPVerification: "",
    customerAPIKeyForOTPVerification: "",
  });

  const [discourseNftTokenGatingData, setDiscourseNftTokenGatingData] =
    useState([
      {
        categoryId: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);

  const [nftCustomizationDetails, setNftCustomizationDetails] = useState({
    connectWalletButtonText: "Connect Wallet",
    connectWalletButtonColor: "#000000",
    connectWalletButtonTextColor: "#ffffff",
    pageTitle: "Discourse Crypto Wallet Login",
    pageTitleTextColor: "#000000",
    pageDescription:
      "This wallet address is not mapped with your email. Please verify your email and map it with your wallet address which you had connected.",
    pageDescriptionTextColor: "#000000",
    customBackground: "",
  });

  const onHandleDiscourseDetailsInputChange = (event) => {
    const { name, value } = event.target;
    setDiscourseDetails({
      ...discourseDetails,
      [name]: value,
    });
  };

  const onHandleDiscourseNftTokenGatingDataInputChange = (event, index) => {
    const { name, value } = event.target;
    const listOfConfiguration = [...discourseNftTokenGatingData];
    listOfConfiguration[index][name] = value;
    setDiscourseNftTokenGatingData(listOfConfiguration);
  };

  const onHandleNftCustomizationInputChange = (event) => {
    const { name, value } = event.target;
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: value,
    });
  };

  const onHandleCustomLogo = async (event) => {
    const data = event.target.files[0];
    if (data.size > 5 * 1000000) {
      swal({
        title: "Size is greater than 5 MB.",
        icon: "error",
      });
    } else {
      const { name, value } = event.target;
      const formData = new FormData();
      formData.append("image", data);
      let response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/upload-logo`,
        data: formData,
        headers: {
          "content-type": "application/json",
        },
      });
      let imageId = response.data.response;
      let imagePath = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BASE_URL}` + "/uploads/" + imageId,
      });

      imagePath = imagePath.config.url;
      imagePath = imagePath.replace(/\\/g, "/");

      setNftCustomizationDetails({
        ...nftCustomizationDetails,
        [name]: imagePath,
      });
    }
  };

  const handleRemoveClick = (index) => {
    const listOfConfiguration = [...discourseNftTokenGatingData];
    listOfConfiguration.splice(index, 1);
    setDiscourseNftTokenGatingData(listOfConfiguration);
  };

  const handleAddClick = () => {
    setDiscourseNftTokenGatingData([
      ...discourseNftTokenGatingData,
      {
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };

  const handleNext = (event) => {
    event.preventDefault();
    setActiveStep((prevStep) => prevStep + 1);
    if (activeStep === steps.length - 1) {
      setActiveStep((prevStep) => prevStep - 1);
      for(let index = 0 ; index < discourseNftTokenGatingData.length ; index++){
        let dataObject = discourseNftTokenGatingData[index]
        for (const key in dataObject){
          dataObject[key] =  dataObject[key].replace(/\s+/g, "") 
          }
       }       

      let modifiedForumLink = discourseDetails.forumLink.replace(/\s/g, '')
      let discourseTokenGatingData = {
        forumLink: modifiedForumLink.charAt(modifiedForumLink.length - 1) === '/' ? modifiedForumLink.slice(0, -1) : modifiedForumLink,
        discourseAPI: discourseDetails.discourseAPI.replace(/\s/g, ''),
        adminForumUserName: discourseDetails.adminForumUserName.replace(/\s/g, ''),
        discourseConnectSecret: discourseDetails.discourseConnectSecret.replace(/\s/g, ''),
        otpVerificationKey: {
          customerKeyForOTPVerification:
            discourseDetails.customerKeyForOTPVerification.replace(/\s/g, ''),
          customerAPIKeyForOTPVerification:
            discourseDetails.customerAPIKeyForOTPVerification.replace(/\s/g, ''),
        },
        discourseNftTokenGatingData,
      };
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/discourse-nft-token-gating-data-save`,
          {
            discourseTokenGatingData,
            nftCustomizationDetails,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          swal({
            text: "Discourse NFT Token Gating has been enabled ",
            icon: "success",
          });
          navigate("/configured-apps");
        })
        .catch((err) => {
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    }
  };
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const formContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DiscourseDetails
            onHandleDiscourseDetailsInputChange={
              onHandleDiscourseDetailsInputChange
            }
            discourseDetails={discourseDetails}
          />
        );
      case 1:
        return (
          <DiscourseTokenGatingConfiguration
            onHandleDiscourseNftTokenGatingDataInputChange={
              onHandleDiscourseNftTokenGatingDataInputChange
            }
            onHandleDiscourseDetailsInputChange={
              onHandleDiscourseDetailsInputChange
            }
            discourseDetails={discourseDetails}
            discourseNftTokenGatingData={discourseNftTokenGatingData}
            handleRemoveClick={handleRemoveClick}
            handleAddClick={handleAddClick}
          />
        );
      case 2:
        return (
          <Box style={{ margin: "40px", marginLeft: "60px" }}>
            <DiscourseBrandingDetails
              onHandleNftCustomizationInputChange={
                onHandleNftCustomizationInputChange
              }
              nftCustomizationDetails={nftCustomizationDetails}
              onHandleCustomLogo={onHandleCustomLogo}
            />
          </Box>
        );
      default:
        return <div>404: Not Found</div>;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "1000px",
        padding: 2,
        ml: 10,
      }}
    >
      <form onSubmit={handleNext}>
        <Box
          variant="gradient"
          borderRadius="lg"
          shadow="lg"
          opacity={1}
          p={3}
          textAlign="left"
          sx={{ bgcolor: "#f2f0f0", boxShadow: 2, height: 70 }}
        >
          <Stepper
            activeStep={activeStep}
            sx={{ fontSize: 10 }}
            orientation="horizontal"
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Grid container>
          <Grid item xs={12} sx={{ padding: "20px" }}>
            {formContent(activeStep)}
          </Grid>
          <Grid item xs={12}>
            <Button
              size="small"
              variant="contained"
              className="custom-color-button"
              disabled={activeStep == 0}
              sx={{
                ml: 11,
                mt: 1,
                mb: 3,
                boxShadow: 2,
              }}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              type="submit"
              size="small"
              variant="contained"
              className="custom-color-button"
              sx={{
                ml: 2,
                mt: 1,
                mb: 3,
                boxShadow: 2,
              }}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DiscourseTokenGatingForm;
